import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EventStream from './EventStream';
import ConfirmDialog from './ConfirmDialog';
import { dateSort, getLocalDateTimeFromIso  , getAssignedToFullName } from '../../helpers/utils';
import { isEmptyObject } from '../../validators/formValidators';


export const getInvoiceItems = (currentCase, loggedIn, employees) => {
    if (isEmptyObject(currentCase)) {
        return undefined;
    }

    // Case Events

    let caseEvents = [];
    if (currentCase.events) {
        caseEvents = currentCase.events.filter(e => !e['$InvoiceId$']).map((evt) => {
            const event = { ...evt };
            event['EventDate'] = getLocalDateTimeFromIso(loggedIn, event['EventDate'] || event['created_at']);
            event['$Sender$'] = getAssignedToFullName(event['SenderId'], loggedIn, employees);
            return event;
        });
    }

    let charges = [];
    if (currentCase.charges) {
        charges = currentCase.charges.filter(e => e['amount'] > 0 && (e['$AmountRemaining$'] == undefined || e['$AmountRemaining$'] > 0)).map(v => {
            const row = { ...v };
            row['EventType'] = 'Charge';
            row['EventDate'] = getLocalDateTimeFromIso(loggedIn, row['EventDate'] || row['created_at']);
            row['$Sender$'] = getAssignedToFullName(v['$SenderId$'], loggedIn, employees);
            return row;
        });
    }

    let events = [ ...caseEvents, ...charges ];
    events = events.sort((a, b) => {
        return dateSort(a['EventDate'], b['EventDate'], () => {
            return dateSort(a['created_at'], b['created_at']);
        });
    });

    return events;
}


class LoadInvoiceItemsDialog extends PureComponent {
    constructor(props) {
        super(props)
        this.onSelected = this.onSelected.bind(this);
        this.confirm = this.confirm.bind(this);
        this.events = [];
        this.state = {
            selectedIds: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.dialogOpen && nextProps.dialogOpen) {
            this.setState({selectedIds: nextProps.selectedIds});
            this.forceUpdate();
        }
    }

    onSelected(event) {
        const selectedIds = {...this.state.selectedIds};
        if (selectedIds[event.id]) {
            delete selectedIds[event.id];
        } else {
            selectedIds[event.id] = event;
        }

        this.setState({selectedIds});
        this.forceUpdate();
    }

    confirm() {
        this.props.dialogConfirm(this.state.selectedIds);
    }

    render() {
        return (
            <ConfirmDialog
                title='Select entries to create invoice'
                open={this.props.dialogOpen}
                size='large'
                confirm={this.confirm}
                cancel={this.props.dialogCancel}
            >
                <EventStream
                    filter={['Time', 'Cost', 'Charge']}
                    onSelected={this.onSelected}
                    selectedIds={this.state.selectedIds}
                    selectableFilter={e => {
                        if (e['EventType'] == 'Time' || e['EventType'] == 'Cost') {
                            return !e['$InvoiceId$'];
                        }
                        if (e['EventType'] == 'Charge') {
                            return e['$ChargeType$'] == 'charge' && e['EventStatus'] == 'Success' && e['amount'] > 0 && (e['$AmountRemaining$'] == undefined || e['$AmountRemaining$'] > 0);
                        }
                        return false;
                    }}
                />
            </ConfirmDialog>
        );
    }
};


LoadInvoiceItemsDialog.propTypes = {
    selectedIds: PropTypes.object,
    dialogOpen: PropTypes.bool.isRequired,
    dialogConfirm: PropTypes.func.isRequired
};

export default LoadInvoiceItemsDialog;
